module.exports = __webpack_public_path__ + "static/media/bars1-and-notes.74d04948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bars1-and-notes.png
// module id = 53
// module chunks = 0